export const SET_SHOW_LOADING = 'SET_SHOW_LOADING';
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';

export const SET_SHOW_PENDING = 'SET_SHOW_PENDING';

export const SET_SHOW_SEARCHING = 'SET_SHOW_SEARCHING';

export const SET_PORTAL_MODAL = 'SET_PORTAL_MODAL';

export const SET_SHOW_BACKDROP = 'SET_SHOW_BACKDROP';

export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';

export const SET_EXCHANGE_RATES = 'SET_EXCHANGE_RATES';

export const SET_REMITTANCE_RATES = 'SET_REMITTANCE_RATES';
export const SET_REMITTANCE_RATES_SELECTED = 'SET_REMITTANCE_RATES_SELECTED';

export const SET_SERVICE_ALERTS_BY_COUNTRY_CODE =
  'SET_SERVICE_ALERTS_BY_COUNTRY_CODE';
export const SET_SERVICE_ALERTS_BY_PAYMENTS = 'SET_SERVICE_ALERTS_BY_PAYMENTS';

export const SET_SERVICE_ALERTS_METHOD_CHECK =
  'SET_SERVICE_ALERTS_METHOD_CHECK';

export const SET_NEW_NOTIFICATION = 'SET_NEW_NOTIFICATION';

export const SET_CURRENT_RECEIVER = 'SET_CURRENT_RECEIVER';

export const SET_CURRENT_BUSINESS_RECEIVER = 'SET_CURRENT_BUSINESS_RECEIVER';

export const SET_REGISTER_INFORMATION = 'SET_REGISTER_INFORMATION';

export const SET_OPEN_REFRESH_TOKEN_POPUP = 'SET_OPEN_REFRESH_TOKEN_POPUP';

export const SET_EDIT_RECEIVER_INFORMATION = 'SET_EDIT_RECEIVER_INFORMATION';
export const SET_EDIT_RECEIVER_CURRENT_STEP = 'SET_EDIT_RECEIVER_CURRENT_STEP';

export const SET_ADD_RECEIVER_INFORMATION = 'SET_ADD_RECEIVER_INFORMATION';

export const SET_ADD_TRANSACTION_INFORMATION =
  'SET_ADD_TRANSACTION_INFORMATION';
export const SET_ADD_TRANSACTION_CURRENT_STEP =
  'SET_ADD_TRANSACTION_CURRENT_STEP';

export const SET_TRANSACTION_DETAILS = 'SET_TRANSACTION_DETAILS';

export const SET_TOKEN_TRANSACTION = 'SET_TOKEN_TRANSACTION';

export const SET_CONFIG_OCCUPATION = 'SET_CONFIG_OCCUPATION';

export const SET_CONFIG_RELATIONSHIP = 'SET_CONFIG_RELATIONSHIP';

export const SET_CONFIG_RELATIONSHIP_OF_BUSINESS =
  'SET_CONFIG_RELATIONSHIP_OF_BUSINESS';

export const SET_CONFIG_PURPOSE = 'SET_CONFIG_PURPOSE';

export const SET_CONFIG_PURPOSE_OF_BUSINES = 'SET_CONFIG_PURPOSE_OF_BUSINES';

export const SET_CONFIG_SOURCES_OF_WEALTH = 'SET_CONFIG_SOURCES_OF_WEALTH';

export const SET_EVENT_AVAILABLE = 'SET_EVENT_AVAILABLE';

export const SET_REFRESH_RECEIVER_LIST = 'SET_REFRESH_RECEIVER_LIST';

export const SET_REFRESH_TRANSACTION_LIST = 'SET_REFRESH_TRANSACTION_LIST';

export const SET_MENU_EXPAND = 'SET_MENU_EXPAND';

export const SET_EVENTS = 'SET_EVENTS';

export const SET_EVENTS_ON_SIDEBAR = 'SET_EVENTS_ON_SIDEBAR';

export const SET_REFERRAL_PARTICIPANTS = 'SET_REFERRAL_PARTICIPANTS';

export const SET_TRANSACTIONS_EMPTY = 'SET_TRANSACTIONS_EMPTY';
export const SET_TRANSACTIONS_COMPLETED_EMPTY =
  'SET_TRANSACTIONS_COMPLETED_EMPTY';
export const SET_ALL_TRANSACTIONS_AS_CANCELLED =
  'SET_ALL_TRANSACTIONS_AS_CANCELLED';

export const SET_ADD_PAYTO_ACCOUNT_INFORMATION =
  'SET_ADD_PAYTO_ACCOUNT_INFORMATION';
export const SET_PAYTO_BANK_ACCOUNTS_VERIFIED =
  'SET_PAYTO_BANK_ACCOUNTS_VERIFIED';
export const SET_PAYTO_ACCOUNTS_AGREEMENT = 'SET_PAYTO_ACCOUNTS_AGREEMENT';
export const SET_PAYTO_MAX_AMOUNT_EDITED = 'SET_PAYTO_MAX_AMOUNT_EDITED';
export const SET_PAYTO_ACCOUNT_AUTHORISING = 'SET_PAYTO_ACCOUNT_AUTHORISING';
export const SET_ACCOUNT_AGREEMENT_EDITING = 'SET_ACCOUNT_AGREEMENT_EDITING';
export const SET_PAYTO_PAYID_GENERATION = 'SET_PAYTO_PAYID_GENERATION';
export const SET_PAYTO_CREATE_LIMIT = 'SET_PAYTO_CREATE_LIMIT';
export const SET_PAYTO_AMEND_LIMIT = 'SET_PAYTO_AMEND_LIMIT';
// DEV-1401: per-call pending signals for the Create-flow limit lookups --
// deliberately separate from SET_SHOW_LOADING (that flag is shared by >=3
// unrelated HOCs and would false-positive on unrelated concurrent requests).
// BSB has two applicable calls (the BSB-number check and the BSB-account
// check); PayID has one.
export const SET_PAYTO_BSB_NUMBER_CHECK_PENDING =
  'SET_PAYTO_BSB_NUMBER_CHECK_PENDING';
export const SET_PAYTO_BSB_ACCOUNT_CHECK_PENDING =
  'SET_PAYTO_BSB_ACCOUNT_CHECK_PENDING';
export const SET_PAYTO_PAYID_CHECK_PENDING = 'SET_PAYTO_PAYID_CHECK_PENDING';
export const SET_PAYTO_PAYID_BANK_VALIDATION_FAILURE =
  'SET_PAYTO_PAYID_BANK_VALIDATION_FAILURE';

export const SET_SIGNUP_PII_INFORMATION = 'SET_SIGNUP_PII_INFORMATION';

export const SET_FORM_PROFILE_KYC_INFORMATION =
  'SET_FORM_PROFILE_KYC_INFORMATION';

export const SET_PROFILE_OCCUPATION = 'SET_PROFILE_OCCUPATION';

export const SET_CALCULATOR_ROUNDING = 'SET_CALCULATOR_ROUNDING';
export const SET_CALULATOR_ROUNDING_PUBLIC_RESPONSE =
  'SET_CALULATOR_ROUNDING_PUBLIC_RESPONSE';
export const SET_CALULATOR_ROUNDING_RESPONSE =
  'SET_CALULATOR_ROUNDING_RESPONSE';
export const SET_CURRENT_NOTIFY_DATA = 'SET_CURRENT_NOTIFY_DATA';
